import { Component, input } from '@angular/core';
import { LegalConfig } from '@vueling-ng/vy-ds/src/lib/components/composed/footer';
import { AgencyListNavigationItem, CorporateListNavigationItem, extendedLegalConfig } from './footer.config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  public language = input.required<string>();
  public userType = input.required<string>();

  public legalConfigFooter: LegalConfig = { footerLegalTitle: '', itemsLegalFooter: [] };

  public loadConfigFooter(userType: string | undefined): LegalConfig {
    if (userType === 'agency') {
      extendedLegalConfig.itemsLegalFooter = AgencyListNavigationItem;
    }

    if (userType === 'corporate') {
      extendedLegalConfig.itemsLegalFooter = CorporateListNavigationItem;
    }
    return extendedLegalConfig;
  }
}
